import React from 'react';
import { Flame, Trophy, CalendarCheck } from 'lucide-react';
import './StreakCard.css';

/**
 * Reusable Streak Performance Card
 * @param {Object} streak - Streak object containing currentStreak, highestStreak, totalActiveDays, isCompletedToday
 * @param {string} [className] - Optional container class override
 */
const StreakCard = ({ streak = {}, className = '' }) => {
  const {
    currentStreak = 0,
    highestStreak = 0,
    totalActiveDays = 0,
    isCompletedToday = false,
  } = streak;

  return (
    <div className={`streak-card-wrapper ${isCompletedToday ? 'active' : 'pending'} ${className}`}>
      {/* Primary Flame Header Block */}
      <div className="streak-main-banner">
        <div className={`streak-flame-circle ${isCompletedToday ? 'flame-active' : 'flame-pending'}`}>
          <Flame size={32} className="streak-flame-icon" />
        </div>
        <div className="streak-main-info">
          <div className="streak-number-row">
            <span className="streak-count-value">{currentStreak}</span>
            <span className="streak-count-label">Day Streak</span>
          </div>
          <p className="streak-status-text">
            {isCompletedToday ? (
              <span className="status-badge status-active">🔥 Active Today!</span>
            ) : (
              <span className="status-badge status-pending">⚡ Complete a quiz today to keep it going</span>
            )}
          </p>
        </div>
      </div>

      {/* Secondary Stats Grid */}
      <div className="streak-stats-grid">
        <div className="streak-stat-item">
          <div className="stat-icon-wrapper trophy-bg">
            <Trophy size={16} />
          </div>
          <div>
            <span className="stat-label">Longest Streak</span>
            <strong className="stat-value">{highestStreak} Days</strong>
          </div>
        </div>

        <div className="streak-stat-item">
          <div className="stat-icon-wrapper calendar-bg">
            <CalendarCheck size={16} />
          </div>
          <div>
            <span className="stat-label">Total Active Days</span>
            <strong className="stat-value">{totalActiveDays} Days</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreakCard;